function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M51.3,12.3v142.8c0,2-1.6,3.6-3.6,3.6h-16c-2,0-3.6-1.6-3.6-3.6V55.7c0-3.8-2.2-7.2-5.6-8.8l-7-3 c-1.8-1-2.6-3-1.8-5l13.4-28c0.6-1.4,2-2.2,3.4-2.2h17.2C49.7,8.7,51.3,10.5,51.3,12.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M117.9,125.9l-6,0.2c-2.2,0-4,1.4-4.6,3.4l-7.2,26.6c-0.4,1.6-1.8,2.6-3.4,2.6H78.3c-2.4,0-4-2.2-3.4-4.6 l22.4-83.4c0.6-2,2.8-3,4.8-2.4l3,1.2c1.2,0.4,2,1.2,2.2,2.4l14,49.4C122.1,123.7,120.3,125.9,117.9,125.9z M112.9,11.1l-6.8,27.2 c-0.4,1.8,0.4,3.6,2,4.2l12.4,5c2.2,1,3.8,2.8,4.4,5l28.6,103.6c0.4,1.6,1.8,2.6,3.4,2.6h18.4c2.4,0,4-2.2,3.4-4.6l-38.6-143 c-0.4-1.6-1.8-2.6-3.4-2.6h-20.2C114.7,8.5,113.3,9.5,112.9,11.1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M207.1,161.7c-9.2,0-16.8-7.4-16.8-16.8c0-9.2,7.6-16.6,16.8-16.6c9.2,0,16.6,7.4,16.6,16.6 C223.7,154.3,216.3,161.7,207.1,161.7z"
});

var SvgMarca1A = function SvgMarca1A(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.7 167.8",
    style: {
      enableBackground: "new 0 0 228.7 167.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarca1A, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marca-1a.45b651c5.svg";
export { ForwardRef as ReactComponent };